module.exports = __webpack_public_path__ + "img/auflauf-1.a7772def.jpg";